
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from '@/components/ui/form';
import { Textarea } from '@/components/ui/textarea';
import { TrainingFormValues } from '../../../types';

interface TechniquesSectionProps {
  form: UseFormReturn<TrainingFormValues>;
}

export const TechniquesSection: React.FC<TechniquesSectionProps> = ({ form }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Techniques</h3>
      <FormField
        control={form.control}
        name="techniques"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Techniques Practiced</FormLabel>
            <FormControl>
              <Textarea 
                placeholder="List techniques practiced during this session..."
                className="min-h-[100px] resize-y"
                {...field} 
                value={field.value || ''}
              />
            </FormControl>
            <FormDescription>
              Tip: Separate technique names with commas (e.g., "Armbar, Triangle, Kimura")
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};
